<template>
  <v-container fluid pa-0 v-bind="$attrs">
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap>
          <slot />
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  inheritAttrs: false,
  components: {},
  props: {},
  data: () => ({}),
}
</script>
